// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

export const S = {
  SupportTypeOptionsWrapper: styled.div`
    background: #FFFFFF;
    border: 1px solid #C9C9C9;
    box-sizing: border-box;
    border-radius: 4px;
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    max-width: 458px;
    height: 50px;
    position: relative;
    padding: 14px 20px 13px 24px;
    cursor: pointer;
  `,
  OptionText: styled.div`
  `,
  OptionTriangle: styled.img`
    margin-left: auto;
    height: 14px;
  `,
  PlaceHolder: styled.span`
    font-size: 16px;
    line-height: 23px;
    color: #A6A6A6;
  `,
  Menu: styled.span`
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    z-index: 1000;
    display: none;
    float: left;
    margin: 2px 0 0;
    font-size: 14px;
    text-align: left;
    list-style: none;
    background: #FFFFFF;
    background-clip: padding-box;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, 0.15);
    max-height: 378px;
    overflow: auto;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    li {
      cursor: pointer;
      :hover {
        background: rgba(201, 201, 201, 0.3)
      }
      padding: 11px 0px 12px 24px;
      & > i {
        display: block;
        clear: both;
        font-weight: 400;
        line-height: 1.42857143;
        color: #333;
        white-space: nowrap;
        text-decoration: none;
        font-size: 16px;
        line-height: 23px;
        color: #575757;
      }
    } `
};
